/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Active_ModuleInputs */

const en_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIVE MODULE`)
};

const ar_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوحدة النشطة`)
};

const bn_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাক্টিভ মডিউল`)
};

const de_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTIVES MODUL`)
};

const es_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MÓDULO ACTIVO`)
};

const fr_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODULE ACTIF`)
};

const pt_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MÓDULO ATIVO`)
};

const zh_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有源模块`)
};

const tr_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTİF MODÜL`)
};

const ru_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`АКТИВНЫЙ МОДУЛЬ`)
};

const pl_experience_active_module = /** @type {(inputs: Experience_Active_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODUŁ AKTYWNY`)
};

/**
* | output |
* | --- |
* | "ACTIVE MODULE" |
*
* @param {Experience_Active_ModuleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_active_module = /** @type {((inputs?: Experience_Active_ModuleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Active_ModuleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_active_module(inputs)
	if (locale === "bn") return bn_experience_active_module(inputs)
	if (locale === "de") return de_experience_active_module(inputs)
	if (locale === "es") return es_experience_active_module(inputs)
	if (locale === "fr") return fr_experience_active_module(inputs)
	if (locale === "pt") return pt_experience_active_module(inputs)
	if (locale === "zh") return zh_experience_active_module(inputs)
	if (locale === "tr") return tr_experience_active_module(inputs)
	if (locale === "ru") return ru_experience_active_module(inputs)
	if (locale === "pl") return pl_experience_active_module(inputs)
	return en_experience_active_module(inputs)
});